function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
import { registerAction, unregisterAction } from 'helpers/reducerTools';
import * as actionTypes from './actionTypes';
const initialState = {
    fetching: [],
    sending: [],
    errors: [],
    clinicKpiStatistics: [],
    kpiSkip: 0,
    totalKpi: 0
};
export default function reducer(state = _object_spread({}, initialState), action = {}) {
    switch(action.type){
        case actionTypes.SEND_STATISTICS:
        case actionTypes.SEND_STATISTICS_FOR_CLINIC:
            {
                return _object_spread_props(_object_spread({}, state), {
                    sending: registerAction(state.sending, actionTypes.SEND_STATISTICS),
                    errors: unregisterAction(state.errors, actionTypes.SEND_STATISTICS)
                });
            }
        case actionTypes.SEND_STATISTICS_SUCCESS:
        case actionTypes.SEND_STATISTICS_FOR_CLINIC_SUCCESS:
            {
                return _object_spread_props(_object_spread({}, state), {
                    sending: unregisterAction(state.sending, actionTypes.SEND_STATISTICS)
                });
            }
        case actionTypes.SEND_STATISTICS_ERROR:
        case actionTypes.SEND_STATISTICS_FOR_CLINIC_ERROR:
            {
                return _object_spread_props(_object_spread({}, state), {
                    sending: unregisterAction(state.sending, actionTypes.SEND_STATISTICS),
                    errors: registerAction(state.errors, actionTypes.SEND_STATISTICS)
                });
            }
        //------------------------------------------------------------------------------------------------------------------
        case actionTypes.FETCH_CLINIC_KPI_STATISTICS:
            {
                return _object_spread_props(_object_spread({}, state), {
                    fetching: registerAction(state.fetching, actionTypes.FETCH_CLINIC_KPI_STATISTICS),
                    errors: unregisterAction(state.errors, actionTypes.FETCH_CLINIC_KPI_STATISTICS)
                });
            }
        case actionTypes.FETCH_CLINIC_KPI_STATISTICS_SUCCESS:
            {
                const { clinicKpiStatistics, kpiSkip, totalKpi } = action.payload;
                return _object_spread_props(_object_spread({}, state), {
                    fetching: unregisterAction(state.fetching, actionTypes.FETCH_CLINIC_KPI_STATISTICS),
                    clinicKpiStatistics,
                    kpiSkip,
                    totalKpi
                });
            }
        case actionTypes.FETCH_CLINIC_KPI_STATISTICS_ERROR:
            {
                return _object_spread_props(_object_spread({}, state), {
                    fetching: unregisterAction(state.fetching, actionTypes.FETCH_CLINIC_KPI_STATISTICS),
                    errors: registerAction(state.errors, actionTypes.FETCH_CLINIC_KPI_STATISTICS)
                });
            }
        //------------------------------------------------------------------------------------------------------------------
        default:
            {
                return state;
            }
    }
}
